import React, { useRef } from 'react'
import { Checkbox } from 'mailup-web-components'
import { selectedResultsStateAllSelected } from '../../recoil/state/results'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import styled from '@emotion/styled'

const StyledCheckbox = styled(Checkbox)`
  color: #7c7c7c;
  font-weight: 400;
  font-size: 15px;

  .c-checkbox__label:before {
    margin-right: 16px;
  }

  &:hover {
    cursor: pointer;
  }
`

export const SelectAll = () => {
  const intl = useIntl()

  const [allSelected, setAllSelected] = useRecoilState(
    selectedResultsStateAllSelected
  )

  const { current: handleChange } = useRef(e => {
    setAllSelected(e.target.checked)
  })

  return (
    <StyledCheckbox
      checked={allSelected}
      onChange={handleChange}
      label={
        allSelected
          ? intl.formatMessage({ id: 'Load.TableHeader.UnselectAll' })
          : intl.formatMessage({ id: 'Load.MailupCommon.BtnSelectAll' })
      }
      labelClassName=''
      data-mu-test='checkbox--select-all'
    />
  )
}
